"use client";

import {
  Tooltip as CnTooltip,
  TooltipContent as CnTooltipContent,
  TooltipTrigger as CnTooltipTrigger,
  TooltipContentVariants,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { VariantProps } from "class-variance-authority";
import { useState } from "react";

export default function Tooltip({
  children,
  content,
  className,
  contentClassName,
  variant,
}: {
  children?: React.ReactNode | React.ReactNode[];
  content: React.ReactNode | React.ReactNode[];
  contentClassName?: string;
  className?: string;
} & VariantProps<typeof TooltipContentVariants>) {
  const [open, setOpen] = useState(false);
  return (
    <CnTooltip
      open={open}
      delayDuration={200}
      onOpenChange={(newOpen) => setOpen(newOpen)}
    >
      <CnTooltipTrigger
        asChild={false}
        className={cn(
          "bg-transparent p-0 text-matchbus hover:cursor-default focus:outline-0",
          open && "scale-105",
          className,
        )}
        onClick={(e) => {
          e.preventDefault();
          !open && setOpen(true);
        }}
      >
        {children}
      </CnTooltipTrigger>
      <CnTooltipContent
        className={cn(
          typeof content === "string" && "max-w-[25rem]",
          contentClassName,
        )}
        variant={variant}
      >
        {content}
      </CnTooltipContent>
    </CnTooltip>
  );
}
